module.exports = __webpack_public_path__ + "static/forlarren-062ce5cf0f3e810dce995de2e03a7f16.jpeg";